// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2azzC","icon":"styles_icon__3kJh1"};